import { render } from "./RelatedKeywords.vue?vue&type=template&id=575fd219&scoped=true"
import script from "./RelatedKeywords.vue?vue&type=script&lang=js"
export * from "./RelatedKeywords.vue?vue&type=script&lang=js"

import "./RelatedKeywords.scss?vue&type=style&index=0&id=575fd219&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575fd219"]])

export default __exports__